import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { InventoryOutputDetailModel } from 'src/app/models/inventory/inventory-output-detail.model';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { RentalStockTableModel } from 'src/app/models/tables/rental/rental-stock-table.model';
import { SubrentalOutputDetailCaptureTableModel } from 'src/app/models/tables/subrental/subrental-output-detail-capture-table.model';
import { SubrentalOutputDetailTableModel } from 'src/app/models/tables/subrental/subrental-output-detail-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubrentalOutputDetailService {

  constructor(private _httpClient: HttpClient) { }

  createSubrentalOutputDetail(subrentalOutputDetailContract: InventoryOutputDetailModel): Observable<InventoryOutputDetailModel> {
    return this._httpClient.post<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.CreateSubrentalOutputDetail}`,
      subrentalOutputDetailContract);
  }

  deleteSomeDetails(subrentalOutputDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.DeleteSomeDetails}`,
      subrentalOutputDetailIds);
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.ExportDetailConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  deleteSubrentalOutputDetail(subrentalOutputDetailId: number): Observable<InventoryOutputDetailModel> {
    return this._httpClient.delete<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.DeleteSubrentalOutputDetail}/${subrentalOutputDetailId}`);
  }

  getColumnsForArticles(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.GetColumnsForArticles}`);
  }

  getColumnsForDetailCapture(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.GetColumnsForDetailCapture}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.GetColumnsForDetailConsultation}`);
  }

  getListStocksInShop(subrentalOutputId: number, storeId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<RentalStockTableModel>> {
    const params = new HttpParams()
      .set('subrentalOutputId', subrentalOutputId)
      .set('storeId', storeId)
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<RentalStockTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.GetListStocksInShop}`,
      filters, { params: params }
    );
  }

  getStocksByArticleIdStoreId(rentalStockModel: RentalStockModel): Observable<number> {
    return this._httpClient.post<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.GetStocksByArticleIdStoreId}`,
      rentalStockModel);
  }

  getSubrentalOutputDetailById(subrentalOutputDetailId: number): Observable<InventoryOutputDetailModel> {
    return this._httpClient.get<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.GetSubrentalOutputDetailById}/${subrentalOutputDetailId}`);
  }

  getSubrentalOutputDetailByKeys(subrentalOutputId: number, storeId: number, articleId: number): Observable<InventoryOutputDetailModel> {
    const params = new HttpParams()
      .set('subrentalOutputId', subrentalOutputId)
      .set('storeId', storeId)
      .set('articleId', articleId);
    return this._httpClient.get<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.GetSubrentalOutputDetailByKeys}`,
      { params: params });
  }

  getSubrentalOutputDetailByOutputId(subrentalOutputId: number): Observable<Array<InventoryOutputDetailModel>> {
    return this._httpClient.get<Array<InventoryOutputDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.GetSubrentalOutputDetailByOutputId}/${subrentalOutputId}`);
  }

  getSubrentalOutputDetailsForCapture(subrentalOutputId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean): Observable<PagedResponseModel<SubrentalOutputDetailCaptureTableModel>> {
    const params = new HttpParams()
      .set('subrentalOutputId', subrentalOutputId)
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.get<PagedResponseModel<SubrentalOutputDetailCaptureTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.GetSubrentalOutputDetailsForCapture}`,
      { params: params }
    );
  }

  getSubrentalOutputDetailsForDetailConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<SubrentalOutputDetailTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<SubrentalOutputDetailTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.GetSubrentalOutputDetailsForDetailConsultation}`,
      filters, { params: params }
    );
  }

  updateSubrentalOutputDetail(subrentalOutputDetailContract: InventoryOutputDetailModel): Observable<InventoryOutputDetailModel> {
    return this._httpClient.put<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalOutputDetail.UpdateSubrentalOutputDetail}`,
      subrentalOutputDetailContract);
  }

}
